import { CalculatorHome } from './pages/CalculatorHome';
import { RedirectToHome } from '../../shared/components/RedirectToHome';
import { ClinicalExaminations } from './pages/ClinicalExaminations';
import { Operations } from './pages/Operations';
import { Workforce } from './pages/Workforce';
import { Economical } from './pages/Economical';
import { Resources } from './pages/Resources';
import React from 'react';
import { CalculatorParamsOutlet } from './pages/CalculatorParamsOutlet';
import { CalculatorMenuParams } from '../../shared/classes/CalculatorMenuParams';

const menuList = [
    'home',
    'economical',
    'resources'
] as const;

export type MenuType = typeof menuList[number];

class CalculatorParams implements CalculatorMenuParams {

    label = 'EVC for IGS OnWatch Predict';

    prefix = 'igsow';

    description = 'Simulate the economical impact of a system hard down or in limited use';

    routes = {
            path: this.prefix,
            element: <CalculatorParamsOutlet/>,
            children: [
                {
                    path: 'home',
                    element: <CalculatorHome/>
                },
                {
                    path: '',
                    element: <RedirectToHome/>,
                    children: [
                        {
                            path: 'clinical-examinations',
                            element: <ClinicalExaminations/>
                        },
                        {
                            path: 'operations',
                            element: <Operations/>
                        },
                        {
                            path: 'workforce',
                            element: <Workforce/>
                        }
                    ]
                },
                {
                    path: 'economical',
                    element: <Economical/>
                },
                {
                    path: 'resources',
                    element: <Resources/>
                },
            ],
        }

}

export const calculatorParams = new CalculatorParams();
